import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import type { AddCouponWithClient, AddOrganisationRequest, AddServiceCategoryRequest, CouponCodes, CouponServicesResponse, CreateCouponMasterRequest, EligibleCoupons, GenerateCouponCodesRequest, UpdateCouponLinkRequest, UpdateCouponMasterRequest } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AppErrors, NotFoundError } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  createCoupon(tenantId: number,createCouponMasterRequest: CreateCouponMasterRequest) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.CREATE_COUPON
      .replace('{tenant_id}', tenantId.toString());
    return this.http.post(url,createCouponMasterRequest,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateCouponMaster(tenantId: number,couponMasterId: number, updateCouponMasterRequest: UpdateCouponMasterRequest)
  {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.UPDATE_COUPON
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponMasterId.toString());
    return this.http.put(url,updateCouponMasterRequest,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  // Charge Master
  getCoupons(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams()
    if (allParams.length > 0) {

      allParams.forEach((p: any) => {

        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.GET_COUPONS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSingleCoupon(tenantId: number, couponId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.GET_COUPON_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.get(url,this.httpOptions )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCouponsByMasterid(tenantId: number, couponId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.GET_COUPON_CODES
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  getEligibleClients(tenantId: number, couponId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.GET_ELIGIBLE_CLIENTS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
  AddEligibleClients(tenantId: number, couponId: number, addClientToCoupon:AddCouponWithClient) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.ADD_ELIGIBLE_CLIENTS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.post(url, addClientToCoupon,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  RemoveEligibleClients(tenantId: number, couponId: number, coupon_client_link_id:number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.REMOVE_ELIGIBLE_CLIENT
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString())
      .replace('{client_link_id}', coupon_client_link_id.toString());
    return this.http.delete(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GenerateMoreCoupons(tenantId: number, couponId: number, generateCoupons:GenerateCouponCodesRequest) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.GENERATE_COUPON_CODES
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.post(url, generateCoupons,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateCoupenMasterCouponLink(tenantId: number, couponMasterId: number,couponMasterCouponLinkId: number, updateCoupon:UpdateCouponLinkRequest) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.UPDATE_COUPON_CODE_LINK
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponMasterId.toString())
      .replace('{coupon_link_id}', couponMasterCouponLinkId.toString());
    return this.http.put(url, updateCoupon,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkCouponCodeLinkActive(tenantId: number, couponMasterId: number,couponMasterCouponLinkId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.MARK_COUPON_CODE_ACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponMasterId.toString())
      .replace('{coupon_link_id}', couponMasterCouponLinkId.toString());
    return this.http.post(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkCouponCodeLinkInActive(tenantId: number, couponMasterId: number,couponMasterCouponLinkId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.MARK_COUPON_CODE_INACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponMasterId.toString())
      .replace('{coupon_link_id}', couponMasterCouponLinkId.toString());
    return this.http.post(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkOfferActive(tenantId: number, couponMasterId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.MARK_OFFER_ACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponMasterId.toString());
    return this.http.post(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkOfferInActive(tenantId: number, couponMasterId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.MARK_OFFER_INACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponMasterId.toString());
    return this.http.post(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getEligibleService(tenantId: number, couponId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.GET_ELIGIBLE_SERVICES
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  addEligibleService(tenantId: number, couponId: number, payload:AddServiceCategoryRequest) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.ADD_ELIGIBLE_SERVICE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.post(url, payload, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  removeEligibleService(tenantId: number, couponId: number, couponCodeServiceLinkId:number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.REMOVE_ELIGIBLE_SERVICE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString())
      .replace('{service_link_id}', couponCodeServiceLinkId.toString());
    return this.http.delete(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getEligibleOrganization(tenantId: number, couponId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.GET_ELIGIBLE_ORGANIZATIONS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  addEligibleOrganization(tenantId: number, couponId: number, payload:AddOrganisationRequest) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.ADD_ELIGIBLE_ORGANIZATION
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString());
    return this.http.post(url, payload, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  removeEligibleOrganization(tenantId: number, couponId: number, couponmasterOrganizationId:number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.REMOVE_ELIGIBLE_ORGANIZATION
      .replace('{tenant_id}', tenantId.toString())
      .replace('{coupon_id}', couponId.toString())
      .replace('{org_link_id}', couponmasterOrganizationId.toString());
    return this.http.delete(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getEligibleCoupons(tenantId:number, planId:number): Observable<EligibleCoupons>{
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COUPONS.GET_PLAN_ELIGIBLE_COUPONS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{plan_id}', planId.toString());
    return this.http.get(url, this.httpOptions)
    .pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }



}
